import { Injectable } from '@angular/core';
import { lastValueFrom } from 'rxjs';
import { objectToCamel, objectToSnake } from 'ts-case-convert';
import { IActivePass, ICreateActivePassRequest, IUpdateActivePassRequest } from 'src/app/models';
import { ActivePassesHttpService } from './active-passes.http.service';

@Injectable({
  providedIn: 'root'
})
export class ActivePassesService {

  constructor(private activePassesHttpService: ActivePassesHttpService) { }

  async getByUser(userId: number): Promise<IActivePass[]> {
    const source$ = this.activePassesHttpService.getByUser(userId);
    const response = await lastValueFrom(source$);
    return objectToCamel(response as object[]) as IActivePass[];
  }

  async getByTemporalPass(temporalPassId: number): Promise<IActivePass[]> {
    const source$ = this.activePassesHttpService.getByTemporalPass(temporalPassId);
    const response = await lastValueFrom(source$);
    return objectToCamel(response as object[]) as IActivePass[];
  }

  async createActivePass(body: ICreateActivePassRequest): Promise<IActivePass> {
    const requestBody = objectToSnake(body);
    const source$ = this.activePassesHttpService.createActivePass(requestBody);
    const response = await lastValueFrom(source$);
    return objectToCamel(response as object) as IActivePass;
  }

  async updateActivePass(id: number, body: IUpdateActivePassRequest): Promise<IActivePass> {
    const requestBody = objectToSnake(body);
    const source$ = this.activePassesHttpService.updateActivePass(id, requestBody);
    const response = await lastValueFrom(source$);
    return objectToCamel(response as object) as IActivePass;
  }

  async deleteActivePass(id: number): Promise<void> {
    const source$ = this.activePassesHttpService.deleteActivePass(id);
    await lastValueFrom(source$);
  }
}
